import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

const copyFile = url => (shumaID, fileID) => {
  const data = {
    shumaID: parseInt(shumaID, 10),
    fileID: parseInt(fileID, 10),
  };

  return axios.post(url, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
    });
};

const copyFileFromOrder = url => (shumaID, fileID, fileTypeID) => {
  const data = {
    shumaID: parseInt(shumaID, 10),
    fileID: parseInt(fileID, 10),
    fileTypeID: parseInt(fileTypeID, 10),
  };

  return axios.post(url, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);
    });
};

export const copyOrderFile = copyFileFromOrder(api.COPY_ORDER_FILE);
export const copySharedFile = copyFile(api.COPY_SHARED_FILE);
export const copyPrivateFile = copyFile(api.COPY_PRIVATE_FILE);
